import DangerString from './danger-string';
import React from 'react';

function ServiceTermsAgreement({ stringKey }) {
  return (
    <div className='formish noPaddingTop'>
      <p className='noMarginBelow'>
        <DangerString stringKey={stringKey} />
      </p>
    </div>
  );
}

ServiceTermsAgreement.propTypes = {
  stringKey: DangerString.propTypes.stringKey
};

export default ServiceTermsAgreement;
